import { config } from '../config/environment';
import { AdminTenant, AdminUser, AdminApiResponse } from '../types/admin';

class AdminApiService {
  private baseUrl = config.api.baseUrl;

  private async makeRequest<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<AdminApiResponse<T>> {
    const token = localStorage.getItem('authToken');
    
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Admin API request failed');
    }

    return data;
  }

  async getTenants(): Promise<AdminTenant[]> {
    const response = await this.makeRequest<AdminTenant[]>('/admin/tenants');
    return response.data;
  }

  async getTenantUsers(tenantId: number): Promise<AdminUser[]> {
    const response = await this.makeRequest<AdminUser[]>(`/admin/users?tenant_id=${tenantId}`);
    return response.data;
  }
}

export const adminApi = new AdminApiService();
